import { AppEffects } from './app.effect';
import { ContactEffects } from './contacts.effect';
import { IQObservationEffects } from './get-iq-observations.effect';
import { InvoiceAttachmentEffects } from './invoice-attachments.effect';
import { InvoiceEffects } from './invoices.effect';
import { LineItemEffects } from './line-items.effect';
import { OrderEffects } from './orders.effect';
import { PaymentEffects } from './payments.effect';
import { PortalRoleEffects } from './portal-roles.effect';
import { RouterEffects } from './router.effect';
import { ServiceEffects } from './services.effect';
import { SOFEffects } from './sof.effect';
import { TicketEffects } from './tickets.effect';
import { UserEffects } from './users.effect';

// register effects in here as a whole to keep code well maintained
export const effects: any[] = [
  AppEffects,
  ContactEffects,
  IQObservationEffects,
  InvoiceAttachmentEffects,
  InvoiceEffects,
  LineItemEffects,
  OrderEffects,
  PaymentEffects,
  PortalRoleEffects,
  RouterEffects,
  ServiceEffects,
  SOFEffects,
  TicketEffects,
  UserEffects,
];

export * from './app.effect';
export * from './contacts.effect';
export * from './get-iq-observations.effect';
export * from './invoice-attachments.effect';
export * from './invoices.effect';
export * from './line-items.effect';
export * from './orders.effect';
export * from './payments.effect';
export * from './portal-roles.effect';
export * from './router.effect';
export * from './services.effect';
export * from './sof.effect';
export * from './tickets.effect';
export * from './users.effect';
